module.exports = __webpack_public_path__ + "img/soymomo.c089d69d.png";